export function sharedAccessFromLocation(location) {
  const query = new URLSearchParams(location.search);
  const id = query.get('shared') || (query.get('access') === 'restricted' ? location.pathname.match(/^\/twin\/(0x[0-9a-f]{64})\/?$/i)?.[1] : '');
  if (!/^0x[0-9a-f]{64}$/i.test(id || '')) return null;
  return { id: id.toLowerCase(), integration: query.get('integration') || '' };
}
export function sharedEndpoint(access, suffix) {
  return `/api/shared/twins/${encodeURIComponent(access.id)}/${suffix}${suffix.includes('?') ? '&' : '?'}integration=${encodeURIComponent(access.integration)}`;
}
export async function authorizeSharedAccess(access, keypair, fetcher = fetch) {
  async function post(suffix, body) {
    const response = await fetcher(sharedEndpoint(access, suffix), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    const value = await response.json();
    if (!response.ok) throw new Error(value?.error?.message || value?.error || 'Unable to authorize Twin access');
    return value;
  }
  const challenge = await post('challenge', {});
  const signed = await keypair.signPersonalMessage(new TextEncoder().encode(challenge.message));
  await post('verify', { challengeId: challenge.challengeId, signature: signed.signature });
}
